import { useMutation } from 'data-fetching-client';
import { useDispatch } from 'react-redux';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import UILink from 'UIComponents/link/UILink';
import { DELETE_PREFERRED_CURRENCY, GET_PREFERRED_CURRENCY } from '../../../api/dataFetchingQueries';
import { fetchAggregatedOverviewData } from '../../../actions/AggregatedOverviewDataActions';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
import { jsx as _jsx } from "react/jsx-runtime";
const useDeletePreferredCurrency = ({
  setIsMultiCurrencyPanelOpen
}) => {
  const dispatch = useDispatch();
  const [deletePreferredCurrency] = useMutation(DELETE_PREFERRED_CURRENCY);
  return () => deletePreferredCurrency({
    update(cache) {
      cache.writeQuery({
        query: GET_PREFERRED_CURRENCY,
        data: {
          preferredCurrency: {
            preferredCurrency: ''
          }
        }
      });
    }
  }).then(() => {
    dispatch(fetchAggregatedOverviewData()).catch(error => logRavenException(error, 'Fetch aggregated overview data'));
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "archivedCurrencyAlert.description_jsx",
        options: {
          onClick: () => setIsMultiCurrencyPanelOpen(true)
        }
        // TODO: replace UILink with `Button` from foundations-components when the link styling is ready
        // https://git.hubteam.com/HubSpot/forecasting-team/issues/2409
        ,
        elements: {
          Link: UILink
        }
      }),
      titleText: I18n.text('archivedCurrencyAlert.title'),
      type: 'info'
    });
  });
};
export default useDeletePreferredCurrency;